<template>
    <nav class="nav-bar-static">
        <div class="wrapper">
            <ul v-if="isFontReady" class="uk-nav nav-bar-static__menu" uk-scrollspy-nav="closest: li; scroll: true">
                <li><a href="#services">SERVICES</a></li>
                <li><a href="#partners">PARTNERS</a></li>
                <li><a href="#technologies">TECHNOLOGIES</a></li>
                <li><a href="#contact">CONTACT</a></li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'nav-bar-static',

        data() {
            return {
                isFontReady: false,
            }
        },

        created() {
            document.fonts.ready.then(() => {
                this.isFontReady = true
            })
        },
    }
</script>

<style lang="scss" scoped>
    .nav-bar-static {
        font-family: Raleway;
		font-weight: 600;
        width: 100%;
        height: 90px;
        position: absolute;
        top: 0;
        z-index: 1;

        .wrapper {
            height: 100%;
        }

        &__menu {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 100%;

            li {
                font-size: 14px;
                margin: 20px;
                letter-spacing: 3px;

                a {
                    color: white;

                    &:hover {
                        color: #ff5400;
                    }
                }
            }
        }
    }

    @media all and (max-width: 830px) {
        .nav-bar-static__menu {
            li {
                font-size: 10px;
                margin: 15px;
            }
        }
    }

    @media all and (max-width: 600px) {
        .nav-bar-static__menu {
            justify-content: center;
        }
    }

    @media all and (max-width: 530px) {
        .nav-bar-static__menu {
            li {
                font-size: 8px;
                margin: 6px;
            }
        }
    }
</style>